import debug from 'debug';
import { cookieService } from 'Global/Shared/Components/CookieService/CookieService';
import MultiViewsOverlay from 'Minetilbud/Shared/Components/overlay/multi-views-overlay';
import OverlayBehaviour from 'Minetilbud/Shared/Components/overlay/behaviour';
import Render from './render/render';

const log = debug('SystemOverlays');
const SYSTEMOVERLAY_TEMPLATE_SELECTOR = '#system-overlay-template';
const SYSTEMOVERLAY_COOKIE_NAME = 'system-overlay-target';

class SystemOverlays {
	constructor() {
		this.modalCloseEvent = this.modalCloseHandler.bind(this);
		this.overlayHideEvent = this.overlayHideHandler.bind(this);

		this.initialize();
	}

	eventListeners() {
		document.addEventListener(OverlayBehaviour.eventKeys.hide, this.overlayHideEvent, false);
		document.addEventListener(OverlayBehaviour.eventKeys.modalClose, this.modalCloseEvent, false);
	}

	async initialize() {
		const overlayTemplate = document.querySelector(SYSTEMOVERLAY_TEMPLATE_SELECTOR);
		if (!overlayTemplate) return;

		this.overlay = new MultiViewsOverlay();
		this.instanceId = this.overlay.getInstanceId();

		const render = new Render(this.instanceId, overlayTemplate);
		const renderDom = await render.get();

		this.overlay.create(renderDom);
		this.overlay.show(0);

		this.eventListeners();
	}

	/**
	 * @param {CustomEvent} event
	 */
	 modalCloseHandler({ detail: { options: { instanceId } } }) {
		if (instanceId !== this.instanceId) return;
		this.overlay.hide();
	}

	/**
	 * @param {CustomEvent} event
	 */
	 overlayHideHandler({ detail: { options: { instanceId } } }) {
		if (instanceId !== this.instanceId) return;

		this.overlay.remove();
		cookieService.Delete(SYSTEMOVERLAY_COOKIE_NAME, 0);
	}
}

export default SystemOverlays;
